import { render } from "./date-input.vue?vue&type=template&id=4fe61b70&scoped=true"
import script from "./date-input.vue?vue&type=script&lang=js"
export * from "./date-input.vue?vue&type=script&lang=js"

import "./date-input.vue?vue&type=style&index=0&id=4fe61b70&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe61b70"]])

export default __exports__